module.exports = __webpack_public_path__ + "static/media/goodwood.06a9e6db.jpg";